import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const imageCoachMark = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.75,
  type: 'Image178x100',
  associationType: 'ImageMedia178X100',
  className: 'boost-coachmark',
  imagePreviewHeight: 160,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [280, 160],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('CoachMark'),
    stringKey: _TL_('CoachMark'),
  },
  previewSettings: {
    showDescription: true,
    showShortHeadline: true,
    showBusinessName: false,
    multipleLineLongHeadline: true,
    multipleDescription: true,
    showAction: true,
    showImage: true,
  },
  styleOverrides: {
    cardParent: {
      '& .responsive-ad-preview-content': {
        width: '280px !important',
        height: '300px !important',
      },
      '& .short-headline': {
        left: 20,
        top: 180,
        position: 'absolute',
        fontWeight: 'bold',
        color: 'black',
      },
      '& .description': {
        left: 20,
        top: 210,
        fontSize: 20,
        position: 'absolute',
        color: 'black',
      },
      '& .action-button': {
        backgroundColor: '#0078d4',
        position: 'absolute',
        left: 20,
        top: 260,
        padding: 8,
        fontSize: 15,
        border: 'none',
        color: 'white',
        borderRadius: 5,
      },
    },
  },
};

export default imageCoachMark;
